import { EDateRangeType } from '../../../../pages/advertising-research/model/types/DateRangeType.enum'
import { RadioButton } from '../radio-button/RadioButton'
import { IRadioGroupProps, RadioGroup } from '../radio-group/RadioGroup'
import React from 'react'
import { useDateRanges } from '../../../lib/hooks/UseDateRanges'
import { useTranslation } from 'react-i18next'

export interface IDateRangesParams extends Omit<IRadioGroupProps, 'children'> {
  dateRange: string
  exceptions?: EDateRangeType[]
}

export const DateRanges = (params: IDateRangesParams) => {
  const { t } = useTranslation()
  const { dateRange, exceptions, ...radioGroupProps } = params
  const dateRanges = useDateRanges()

  return (
    <RadioGroup {...radioGroupProps}>
      <RadioButton
        className={`${exceptions?.includes(EDateRangeType.WEEK) && 'hidden'}`}
        defaultChecked={dateRange === dateRanges.week}
        placeholder={t('other.week')}
        value={EDateRangeType.WEEK}
      />
      <RadioButton
        className={`${exceptions?.includes(EDateRangeType.MONTH) && 'hidden'}`}
        defaultChecked={dateRange === dateRanges.month}
        placeholder={t('other.month')}
        value={EDateRangeType.MONTH}
      />
      <RadioButton
        className={`${exceptions?.includes(EDateRangeType.THREE_MONTHS) && 'hidden'}`}
        defaultChecked={dateRange === dateRanges.threeMonths}
        placeholder={t('other.3Months')}
        value={EDateRangeType.THREE_MONTHS}
      />
      <RadioButton
        className={`${exceptions?.includes(EDateRangeType.SIX_MONTHS) && 'hidden'}`}
        defaultChecked={dateRange === dateRanges.sixMonths}
        placeholder={t('other.6Months')}
        value={EDateRangeType.SIX_MONTHS}
      />
      <RadioButton
        className={`${exceptions?.includes(EDateRangeType.YEAR) && 'hidden'}`}
        defaultChecked={dateRange === dateRanges.year}
        placeholder={t('other.1Year')}
        value={EDateRangeType.YEAR}
      />
    </RadioGroup>
  )
}
